module.exports = __webpack_public_path__ + "media/images/banner_osm-e7df6e69e1dfb7f69eec674b6639ebf4.png";